import { createAction, props } from '@ngrx/store';

const GET_ALL_INPUTS = '[Inputs] Get All Inputs';
const GET_ALL_INPUTS_SUCCESS = '[Inputs] Get All Inputs Success';
const GET_ALL_INPUTS_FAILURE = '[Inputs] Get All Inputs Failure';

const UPDATE_FILE_SELECTION = '[Inputs] Update File Selection';
const UPDATE_SELECTED_FILES = '[Inputs] Update Selected Files';
const UPLOAD_NEW_FILE = '[Inputs] Upload New File';
const UPDATE_SELECTED_FILES_SUCCESS = '[Inputs] Update Selected Files Success';
const UPDATE_SELECTED_FILES_FAILURE = '[Inputs] Update Selected Files Failure';
const CLEAR_FILES = '[Inputs] Clear Files';

const getAllFiles = createAction(GET_ALL_INPUTS, props<{ urlPathVariables: { generationId: string } }>());
const getAllFilesSuccess = createAction(
  GET_ALL_INPUTS_SUCCESS,
  props<{ files: any[]; attachmentOrderingInfoSid: string }>()
);
const getAllFilesFailure = createAction(GET_ALL_INPUTS_FAILURE);

const updateFileSelection = createAction(UPDATE_FILE_SELECTION, props<{ fileId: string }>());

const updateSelectedFiles = createAction(
  UPDATE_SELECTED_FILES,
  props<{
    wizardId: string;
    appId: string;
    orgId: string;
    fileIds: any[];
    automaticSteps: string[];
    prototypeCreationNeeded: boolean;
    userPrompt: string;
  }>()
);

const uploadNewFile = createAction(
  UPLOAD_NEW_FILE,
  props<{ files: File[]; attachmentOrderingInfoSid: string; generationId: string }>()
);
const updateSelectedFilesSuccess = createAction(UPDATE_SELECTED_FILES_SUCCESS);
const updateSelectedFilesFailure = createAction(UPDATE_SELECTED_FILES_FAILURE);
const clearFiles = createAction(CLEAR_FILES);

const InputActions = {
  getAllFiles,
  getAllFilesSuccess,
  getAllFilesFailure,
  updateFileSelection,
  updateSelectedFiles,
  uploadNewFile,
  updateSelectedFilesSuccess,
  updateSelectedFilesFailure,
  clearFiles
};

export default InputActions;
